export default __webpack_public_path__ + "static/media/chrome.3de8f138.png";